import React from 'react';
import { Crown, Lock, Star, Zap } from 'lucide-react';
import { hasFeatureAccess, getTierInfo, getUpgradeMessage, getUserTier } from '../utils/subscriptionTiers';

const FeatureGate = ({ 
  user, 
  feature, 
  children, 
  fallback = null,
  showUpgradePrompt = true,
  upgradeButtonText = "Upgrade Now"
}) => {
  const hasAccess = hasFeatureAccess(user, feature);
  
  if (hasAccess) {
    return children;
  }
  
  if (fallback) {
    return fallback;
  }
  
  if (!showUpgradePrompt) {
    return null;
  }
  
  const currentTier = getUserTier(user);
  const tierInfo = getTierInfo(user);
  const upgradeMessage = getUpgradeMessage(currentTier, feature);
  
  return (
    <div className="relative">
      {/* Blurred/disabled content */}
      <div className="filter blur-sm opacity-50 pointer-events-none">
        {children}
      </div>
      
      {/* Upgrade overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-slate-900/95 via-slate-900/80 to-transparent flex items-center justify-center">
        <div className="text-center p-6 max-w-sm">
          <div className="flex justify-center mb-4">
            {currentTier === 'free' && <Crown className="h-12 w-12 text-blue-400" />}
            {currentTier === 'basic' && <Star className="h-12 w-12 text-purple-400" />}
            {currentTier === 'professional' && <Zap className="h-12 w-12 text-yellow-400" />}
          </div>
          
          <h3 className="text-lg font-semibold text-white mb-2">Premium Feature</h3>
          <p className="text-sm text-gray-300 mb-4">{upgradeMessage}</p>
          
          <button
            onClick={() => {
              // Scroll to pricing section
              const pricingElement = document.getElementById('pricing');
              if (pricingElement) {
                pricingElement.scrollIntoView({ behavior: 'smooth' });
              } else {
                window.location.href = '/#pricing';
              }
            }}
            className="bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white px-4 py-2 rounded-lg font-medium transition-all duration-200 flex items-center gap-2 mx-auto"
          >
            <Crown className="h-4 w-4" />
            {upgradeButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeatureGate;